// extracted by mini-css-extract-plugin
export default {"logoContainer":"tNpFvd5LFMxzDKJKL96P","logo":"q9mImiEpIC8XovVCHy5c","heading":"IpR8ozzhc4pOGdt_SEIs","timeTurns":"hbwFfmykllIEugoqHgiH"};